module.exports = __webpack_public_path__ + "img/vertical_4_1_3016.5e992433.png";